// Providers
export const LEADS_PROVIDERS_PENDING = 'LEADS_PROVIDERS_PENDING';
export const LEADS_PROVIDERS_SUCCESS = 'LEADS_PROVIDERS_SUCCESS';
export const LEADS_PROVIDERS_ERROR = 'LEADS_PROVIDERS_ERROR';
export const LEADS_PROVIDER_SUCCESS = 'LEADS_PROVIDER_SUCCESS';

// Mappings
export const LEADS_MAPPINGS_PENDING = 'LEADS_MAPPINGS_PENDING';
export const LEADS_MAPPINGS_SUCCESS = 'LEADS_MAPPINGS_SUCCESS';
export const LEADS_MAPPINGS_ERROR = 'LEADS_MAPPINGS_ERROR';

// Aliases
export const LEADS_ALIASES_PENDING = 'LEADS_ALIASES_PENDING';
export const LEADS_ALIASES_SUCCESS = 'LEADS_ALIASES_SUCCESS';
export const LEADS_ALIASES_ERROR = 'LEADS_ALIASES_ERROR';

// Mailboxes
export const LEADS_MAILBOXES_PENDING = 'LEADS_MAILBOXES_PENDING';
export const LEADS_MAILBOXES_SUCCESS = 'LEADS_MAILBOXES_SUCCESS';
export const LEADS_MAILBOXES_ERROR = 'LEADS_MAILBOXES_ERROR';
export const LEADS_MAILBOX_MESSAGES_PENDING = 'LEADS_MAILBOX_MESSAGES_PENDING';
export const LEADS_MAILBOX_MESSAGES_SUCCESS = 'LEADS_MAILBOX_MESSAGES_SUCCESS';
export const LEADS_MAILBOX_MESSAGES_ERROR = 'LEADS_MAILBOX_MESSAGES_ERROR';

// Subscriptions
export const LEADS_SUBSCRIPTIONS_SUCCESS = 'LEADS_SUBSCRIPTIONS_SUCCESS';

// Processed / monitor
export const LEADS_PROCESSED_PENDING = 'LEADS_PROCESSED_PENDING';
export const LEADS_PROCESSED_SUCCESS = 'LEADS_PROCESSED_SUCCESS';
export const LEADS_PROCESSED_ERROR = 'LEADS_PROCESSED_ERROR';

export const leadProvidersPending = () => ({ type: LEADS_PROVIDERS_PENDING });
export const leadProvidersSuccess = (providers) => ({ type: LEADS_PROVIDERS_SUCCESS, providers });
export const leadProvidersError = (error) => ({ type: LEADS_PROVIDERS_ERROR, error });
export const leadProviderSuccess = (provider) => ({ type: LEADS_PROVIDER_SUCCESS, provider });

export const leadMappingsPending = () => ({ type: LEADS_MAPPINGS_PENDING });
export const leadMappingsSuccess = (mappings) => ({ type: LEADS_MAPPINGS_SUCCESS, mappings });
export const leadMappingsError = (error) => ({ type: LEADS_MAPPINGS_ERROR, error });

export const leadAliasesPending = () => ({ type: LEADS_ALIASES_PENDING });
export const leadAliasesSuccess = (aliases) => ({ type: LEADS_ALIASES_SUCCESS, aliases });
export const leadAliasesError = (error) => ({ type: LEADS_ALIASES_ERROR, error });

export const leadMailboxesPending = () => ({ type: LEADS_MAILBOXES_PENDING });
export const leadMailboxesSuccess = (mailboxes) => ({ type: LEADS_MAILBOXES_SUCCESS, mailboxes });
export const leadMailboxesError = (error) => ({ type: LEADS_MAILBOXES_ERROR, error });

export const leadMailboxMessagesPending = () => ({ type: LEADS_MAILBOX_MESSAGES_PENDING });
export const leadMailboxMessagesSuccess = (mailboxMessages) => ({
	type: LEADS_MAILBOX_MESSAGES_SUCCESS,
	mailboxMessages
});
export const leadMailboxMessagesError = (error) => ({ type: LEADS_MAILBOX_MESSAGES_ERROR, error });

export const leadSubscriptionsSuccess = (subscriptions) => ({
	type: LEADS_SUBSCRIPTIONS_SUCCESS,
	subscriptions
});

export const leadProcessedPending = () => ({ type: LEADS_PROCESSED_PENDING });
export const leadProcessedSuccess = (processed) => ({ type: LEADS_PROCESSED_SUCCESS, processed });
export const leadProcessedError = (error) => ({ type: LEADS_PROCESSED_ERROR, error });
